import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import Pending from "../../../../assets/images/pending 2.png";
import Clock from "../../../../assets/images/ClockBG.png";
import Banner from "../../../../assets/images/Rounds/statusTopBanner.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Accordion } from "react-bootstrap";
import ConfirmationAuditionStar from "./ConfirmationAuditionStar";

const PendingPostDetailsStar = () => {
  const [convertedContent, setConvertedContent] = useState();
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [file, setFile] = useState("");
  const [pdfFile, setPdfFile] = useState("");
  const [pdfData, setPdfData] = useState("");

  const handleChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
  };
  const handlePdfChange = (file) => {
    setPdfFile(URL.createObjectURL(file[0]));
    setPdfData(file[0]);
  };

  return (
    <>
      <div className=" row ">
        <div
          title="Live Now"
          className="col-md-2 align-items-center justify-content-center Souvenir-bt "
        >
          <div className="card meetupCard">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="ad-card-td">
                    <img src={Pending} className="ad-card-img-top" alt="..." />
                  </td>
                  <td className="ad-card-td">
                    <small className="ad-card-small"></small>

                    <small className="ad-card-small">03</small>
                  </td>
                </tr>
              </center>
            </div>
            {/* <Link to="/superstar/audition/live"> */}
            <button
              className="card-footer Souvenir-button  w-100 "
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {" "}
              Pending Audition Post
            </button>
            {/* </Link> */}
          </div>
        </div>
      </div>

      {/* <ConfirmationAuditionStar/> */}

      <div className="mx-1 mt-4 mb-5">
        <Accordion className="bg-dark BGDSas">
          <Accordion.Item className="bg-dark BGDSas mb-3" eventKey="0">
            <Accordion.Header className="bg-dark BGDSas">
              Post making Instraction
            </Accordion.Header>
            <Accordion.Body>
              <div className=" mx-1">
                <div className="card card-bg  bhxd border-warning px-2 ">
                  <center>
                    <div className="TopHead d-flex justify-content-center m-3">
                      <div className="mx-4">
                        <img src={Clock} width="90" alt="" />
                      </div>
                      <div className="TimeDate mt-3">
                        <span className="text-light Tre fw-bold">
                          From submition date
                        </span>
                        <h3 className="text-light Btr fw-bold">23 june 2022</h3>
                      </div>
                    </div>
                  </center>

                  <img src={Banner} alt="" className="img-fluid ImGHx" />

                  <div className="VideoXSA mt-3">
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=ysz5S6PUM-U"
                      className="jxk"
                      width="100%"
                    />
                  </div>

                  <h5 className="text-warning  fw-bold mt-4">
                    Audition Post Title
                  </h5>
                  <p className="text-light mx-4">
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Iusto iste repellendus delectus ducimus quam ratione in,
                    nemo vel adipisci doloribus veritatis, ut quidem earum odit
                    tenetur perferendis nostrum doloremque fuga.
                  </p>

                  <h5 className="text-warning  fw-bold mt-3">
                    Audition Post Description
                  </h5>
                  <p className="text-light mx-4">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Vitae maiores veniam corporis cupiditate, aliquid
                    consequuntur. Sit odio architecto nulla, autem expedita
                    aliquam ab at reiciendis. Expedita culpa illo ducimus
                    quibusdam? Lorem ipsum dolor sit amet consectetur,
                    adipisicing elit. Facere dicta voluptatibus consequuntur,
                    enim eos repudiandae animi hic ea ullam. Ipsa possimus
                    assumenda, facere sequi exercitationem tenetur minima
                    distinctio animi nemo? Lorem ipsum dolor sit amet
                    consectetur, adipisicing elit. Iusto iste repellendus
                    delectus ducimus quam ratione in, nemo vel adipisci
                    doloribus veritatis, ut quidem earum odit tenetur
                    perferendis nostrum doloremque fuga.
                  </p>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item className="bg-dark BGDSas" eventKey="1">
            <Accordion.Header className="bg-dark BGDSas">
              Registation Froum Making From the Start Content
            </Accordion.Header>
            <Accordion.Body>
              <div className="container">
                <div className="row mb-3">
                  <div className="col-md-2 text-light fw-bold mb-1">
                    Description
                  </div>
                  <div className="col-md-10">
                    <CKEditor
                      name=""
                      data=""
                      editor={ClassicEditor}
                      onChange={(event, editor) => {
                        setConvertedContent(editor.getData());
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <label
                    for="staticEmail"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Upload Image
                  </label>

                  <div className="col-sm-10 mb-2">
                    <div className="row my-4">
                      <div className="col-md-2 text-white">
                        <img
                          src={file}
                          className="img-fluid avatar-img-src"
                          alt=""
                        />
                      </div>
                      <div className="col-md-10">
                        <input
                          type="file"
                          name="file"
                          id="file"
                          className="inputfile w-25"
                          onChange={(e) => handleChange(e.target.files)}
                        />
                        <label for="file">
                          <i className="fas fa-cloud-upload-alt"></i> Upload
                          Banner
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <label
                    for="staticEmail"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Upload Video
                  </label>

                  <div className="col-sm-10 mb-2">
                    <div className="row my-4">
                      <div className="col-md-2 text-success">{fileVideo}</div>
                      <div className="col-md-10">
                        <input
                          type="file"
                          name="file"
                          id="setFile"
                          className="inputfile w-25"
                          onChange={(e) => handleVideoChange(e.target.files)}
                        />
                        <label for="setFile">
                          <i className="fas fa-cloud-upload-alt"></i> Upload
                          Video
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <label
                    for="staticEmail"
                    className="col-sm-2 col-form-label text-light "
                  >
                    Upload PDF
                  </label>

                  <div className="col-sm-10 mb-2">
                    <div className="row d-flex justify-content-end my-4">
                      <div className="col-md-2 text-success">
                        {pdfFile}
                        {/* <img
                        src={file}
                        className="img-fluid avatar-img-src"
                        alt=""
                      /> */}
                      </div>
                      <div className="col-md-10 inputeParent">
                        <input
                          type="file"
                          name="file"
                          id="file"
                          className="inputfile w-25"
                          onChange={(e) => handlePdfChange(e.target.files)}
                        />
                        <label for="file">
                          <i className="fa-solid fa-file-pdf"></i> 1 MB Maximum
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex mt-4 mb-3 justify-content-center">
                  <button className="btn bg-info text-light px-3  py-2  fw-bold">
                    Submit
                  </button>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default PendingPostDetailsStar;
